module.exports = __webpack_public_path__ + "img/step1.f44b9027.png";